import React, { useEffect, useRef, useState, lazy, Suspense } from 'react';
import { Theme, ThemeLayout } from './pages/Styles/Theme';
import { ThemeProvider } from 'styled-components';
import { createBrowserRouter, RouterProvider, Outlet, Navigate, useParams, useLocation } from 'react-router-dom';

import './pages/index.css';
import Sidebar from './Components/Sidebar/Sidebar';
import { Layout } from 'antd';
import { Content } from 'antd/es/layout/layout';






import CampaignLandingPage from './pages/Campaigns/CampaignLandingPage';











import { GlobalMasterStyle } from './pages/Styles/MasterStyle';




import Login from './pages/Login/Login';
import PrivateRoute from './Components/common/PrivateRoute';
import NotFoundPage from './Components/common/NotFoundPage';
import RouteErrorPage from './Components/common/RouteErrorPage';
import { useDispatch } from 'react-redux';
import { initializeAuth } from './store/actions/loginAction';
import { initializePermissions } from './store/actions/permissionsAction';





import VerifyInvitation from './pages/VerifyInvitation/VerifyInvitation';
import SetPassword from './pages/SetPassword/SetPassword';


import MagicLinkVerify from './pages/Login/MagicLinkVerify';
import MagicLinkLanding from './pages/Login/MagicLinkLanding';
// "-new" auth pages — visual revamp, hidden behind URL prefix. Logic identical to originals.
import LoginNew from './pages/Login/Login-new';
import MagicLinkVerifyNew from './pages/Login/MagicLinkVerify-new';
import MagicLinkLandingNew from './pages/Login/MagicLinkLanding-new';
import VerifyInvitationNew from './pages/VerifyInvitation/VerifyInvitation-new';
import SetPasswordNew from './pages/SetPassword/SetPassword-new';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword';
import SessionInvalidatedModal from './Components/common/SessionInvalidatedModal';
import SessionExpiredModal from './Components/common/SessionExpiredModal';
import IntercomGate from './Components/common/IntercomGate';
import useWindowWidth, { MOBILE_BREAKPOINT, COMPACT_BREAKPOINT } from './hooks/useWindowWidth';

// Route-level code splitting: heavy authenticated pages load as separate
// chunks so the public pages (login, campaign landing) ship a small bundle.
const Dashboard = lazy(() => import('./pages/Dashboard/Dashboard'));
const CreatePollingAgent = lazy(() => import('./pages/PollingAgents/CreatePollingAgent'));
const PollingAgents = lazy(() => import('./pages/PollingAgents/PollingAgent'));
const PollAgents = lazy(() => import('./pages/PollingAgents/PollAgents'));
const Campaigns = lazy(() => import('./pages/Campaigns/Campaigns'));
const CreateCampaign = lazy(() => import('./pages/Campaigns/CreateCampaign'));
const CampaignDetail = lazy(() => import('./pages/Campaigns/CampaignDetail'));
const SurveysList = lazy(() => import('./pages/Surveys/SurveysList'));
const SetUpStudy = lazy(() => import('./pages/Surveys/SetUpStudy'));
const Preview = lazy(() => import('./pages/Surveys/SurveyComponents/Preview/Preview'));
const Project = lazy(() => import('./pages/Projects/Project'));
const ProjectDetails = lazy(() => import('./pages/Projects/ProjectDetails'));
const ProjectSummaryPreview = lazy(() => import('./pages/Projects/ProjectSummary/ProjectSummaryPreview'));
const Topline = lazy(() => import('./pages/Topline/Topline'));
const SignalDashboardHistory = lazy(() => import('./pages/Projects/SignalDashboardHistory'));
const WeightingManager = lazy(() => import('./pages/Projects/WeightingManager'));
const PromptLibrary = lazy(() => import('./pages/Projects/PromptLibrary/PromptLibrary'));
const HealthCheckList = lazy(() => import('./pages/HealthCheck/HealthCheckList'));
const HealthCheckDetail = lazy(() => import('./pages/HealthCheck/HealthCheckDetail'));
const ReadoutList = lazy(() => import('./pages/Readouts/ReadoutList'));
const ReadoutDetail = lazy(() => import('./pages/Readouts/ReadoutDetail'));
const PocList = lazy(() => import('./pages/Poc/PocList'));
const LiveModelCall = lazy(() => import('./pages/Poc/LiveModelCall'));
const ElevenLabsAgentPoc = lazy(() => import('./pages/Poc/ElevenLabsAgent'));
const DefaultGpt = lazy(() => import('./pages/Projects/DefaultGpt'));
const GptChat = lazy(() => import('./pages/Projects/GptChat'));
const Share = lazy(() => import('./pages/Surveys/Share/Share'));
const Gpt = lazy(() => import('./pages/Projects/Gpt'));
const InsightEngineChat = lazy(() => import('./pages/Projects/InsightEngineChat'));
const CreateSurvey = lazy(() => import('./pages/Surveys/CreateSurvey'));
const LaunchSurvey = lazy(() => import('./pages/Surveys/LaunchSurvey'));
const Manage = lazy(() => import('./pages/Manage/Manage'));
const Organization = lazy(() => import('./pages/Organization/Organization'));
const AddEditOrganization = lazy(() => import('./pages/Organization/AddEditOrganization'));
const InsightEngine = lazy(() => import('./pages/Projects/InsightEngine'));
const UserActivity = lazy(() => import('./pages/Monitoring/UserActivity'));
const UserTracking = lazy(() => import('./pages/Monitoring/UserTracking'));
const GenZSignals = lazy(() => import('./pages/Projects/GenZSignals'));
const GenZDashboard = lazy(() => import('./pages/GenZDashboard/GenZDashboard'));
const VitalCityDashboard = lazy(() => import('./pages/VitalCityDashboard/VitalCityDashboard'));
const VitalCityV2Dashboard = lazy(() => import('./pages/VitalCityV2/VitalCityV2Dashboard'));
const CityPulseDashboard = lazy(() => import('./pages/CityPulseDashboard/CityPulseDashboard'));
const CityPulseExceptionQueue = lazy(() => import('./pages/CityPulseDashboard/ExceptionQueue'));
/* Figma redesign of the Vital City dashboard (2026-08-14). Named "New" (not V2)
   on purpose: the vc-quant-foundation-2 branch carries its OWN VitalCityV2
   folder + component, so distinct names keep the merge conflict-free. */
const VitalCityNewDashboard = lazy(() => import('./pages/VitalCityNew/VitalCityNewDashboard'));
const NewCampaign = lazy(() => import('./pages/Campaigns/NewCampaign'));
const LiveStudiesMonitor = lazy(() => import('./pages/Campaigns/LiveStudiesMonitor'));
const SurveyEntry = lazy(() => import('./pages/SurveyEntry/SurveyEntry'));
const AllOrganizations = lazy(() => import('./pages/AllOrganizations/AllOrganizations'));

// Initialize auth on app load
const AppInitializer = ({ children }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Initialize auth and permissions from localStorage
    dispatch(initializeAuth());
    dispatch(initializePermissions());
  }, [dispatch]);

  return <>{children}</>;
};

/* NYC Signal moved to the plural /nyc-signals/ (like /genz-signals/) on
   2026-09-29; chat links shared from the first build (/nyc-signal/<id>?...)
   keep working. */
const LegacyNycSignalChat = () => {
  const { chatId } = useParams();
  const { search, hash } = useLocation();
  return <Navigate to={`/nyc-signals/${encodeURIComponent(chatId)}${search}${hash}`} replace />;
};

// Layout component that includes sidebar and header for all pages
const AppLayout = () => {
  const windowWidth = useWindowWidth();
  const isMobile = windowWidth <= MOBILE_BREAKPOINT;
  const isCompact = windowWidth < COMPACT_BREAKPOINT;

  // localStorage holds the *desktop* preference only. Below COMPACT_BREAKPOINT the
  // sidebar is auto-collapsed to the icon rail; the toggle still works there, but
  // those clicks aren't persisted so the desktop preference survives.
  const [collapsed, setCollapsed] = useState(
    () => isCompact || localStorage.getItem('sidebar_collapsed') === 'true'
  );

  // Re-apply on every crossing of the breakpoint, in both directions.
  const wasCompactRef = useRef(isCompact);
  useEffect(() => {
    if (isCompact === wasCompactRef.current) return;
    wasCompactRef.current = isCompact;
    setCollapsed(isCompact ? true : localStorage.getItem('sidebar_collapsed') === 'true');
  }, [isCompact]);

  const toggle = (data) => {
    setCollapsed(data);
    if (!isCompact) localStorage.setItem('sidebar_collapsed', String(data));
  };

  const sidebarWidth = collapsed ? 60 : 210;

  return (
    <>
      <GlobalMasterStyle />
      <IntercomGate />
      <ThemeLayout>
        <Sidebar collapsed={collapsed} collapsedWidth={60} toggle={(data) => toggle(data)} />
        <Layout>
          <Content
            className="mainContent"
            style={{
              marginLeft: isMobile ? 0 : sidebarWidth,
              width: isMobile ? '100%' : `calc(100% - ${sidebarWidth}px)`,
              transition: 'all 0.2s ease',
            }}
          >
            <div
              style={{
                marginLeft: '0px',
                width: '100%',
              }}
            >
              <main className="appPageContainer px-5 py-4">
                <Suspense fallback={<div style={{ padding: 80, textAlign: "center" }}>Loading…</div>}>
                  <Suspense fallback={<div style={{ padding: 80, textAlign: "center" }}>Loading…</div>}>
                <Outlet />
              </Suspense>
                </Suspense>
              </main>
            </div>
          </Content>
        </Layout>
      </ThemeLayout>
    </>
  );
};

// Layout component without sidebar and header
const NoSidebarLayout = () => {
  return (
    <>
      <GlobalMasterStyle />
      <IntercomGate />
      <ThemeLayout>
        <Layout>
          <Content
            className="mainContentNoSidebar"
            style={{
              marginLeft: 0,
              width: '100%',
              transition: 'all 0.2s ease',
            }}
          >
            <main className="p-0">
              <Suspense fallback={<div style={{ padding: 80, textAlign: "center" }}>Loading…</div>}>
                <Outlet />
              </Suspense>
            </main>
          </Content>
        </Layout>
      </ThemeLayout>
    </>
  );
};

// Define routes
const router = createBrowserRouter([
  {
    // Pathless root: any crash not caught deeper renders the branded
    // full-page fallback instead of React Router's default developer
    // screen ("Unexpected Application Error" / "Hey developer").
    errorElement: <RouteErrorPage standalone />,
    children: [
  {
    // Canonical /login now renders the new visual design. Original <Login /> is
    // kept in the codebase + imported as rollback safety (one-line revert).
    path: '/login',
    element: <LoginNew />,
  },
  // /login-new still mounted so the design URL keeps working for any direct
  // links or tester bookmarks; it's now a duplicate of /login.
  {
    path: '/login-new',
    element: <LoginNew />,
  },
  // Public route for campaign landing page (no auth required)
  {
    path: '/campaign/:slug/:code',
    element: <CampaignLandingPage />,
  },
  {
    path: '/',
    element: (
      <PrivateRoute>
        <AppLayout />
      </PrivateRoute>
    ),
    children: [
      {
        // A crash inside any page: fallback renders in the layout's Outlet,
        // so the sidebar stays and the user can navigate away.
        errorElement: <RouteErrorPage />,
        children: [
      {
        path: '/',
        element: <Dashboard />,
      },
      {
        path: '/polling-agents/',
        element: <PollAgents />,
      },
      {
        path: '/polling-agents/polling-agent',
        element: <PollingAgents />,
      },
      {
        path: '/polling-agents/polling-agent/create-polling-agent',
        element: <CreatePollingAgent />,
      },
      {
        path: '/polling-agents/polling-agent/create-polling-agent/:id',
        element: <CreatePollingAgent />,
      },
      {
        path: '/campaigns/',
        element: <Campaigns />,
      },
      {
        path: '/campaigns/create-campaign',
        element: <CreateCampaign />,
      },
      {
        path: '/campaigns/new-campaign',
        element: <NewCampaign />,
      },
      {
        path: '/campaigns/new-campaign/:id',
        element: <NewCampaign />,
      },
      {
        path: '/campaigns/create-campaign/:id',
        element: <CreateCampaign />,
      },
      {
        path: '/campaigns/live-monitor',
        element: <LiveStudiesMonitor />,
      },
      {
        path: '/campaigns/:id',
        element: <CampaignDetail />,
      },
      {
        path: '/projects/',
        element: <Project />,
      },
      {
        path: '/projects/details/:id',
        element: <ProjectDetails />,
      },
      {
        path: '/projects/summary-preview/:id',
        element: <ProjectSummaryPreview />,
      },
      {
        path: '/topline',
        element: <Topline />,
      },
      {
        path: '/projects/:id/prompt-library',
        element: <PromptLibrary />,
      },
      {
        path: '/projects/:projectId/signals/history',
        element: <SignalDashboardHistory />,
      },
      {
        path: '/projects/:projectId/weighting',
        element: <WeightingManager />,
      },
      {
        path: "/gen-z-dashboard/",
        element: <GenZDashboard />,
      },
      {
        /* Since 2026-09-11 the client-approved redesign is THE Vital City
           dashboard. The original page lives on at /vitalcity-discontinued/
           (kept, not deleted) and the old /vitalcity-new/ link redirects here. */
        path: "/vitalcity/",
        element: <VitalCityNewDashboard />,
      },
      {
        path: "/vitalcity-discontinued/",
        element: <VitalCityDashboard />,
      },
      {
        path: "/vitalcity/v2",
        element: <VitalCityV2Dashboard />,
      },
      {
        path: "/vitalcity/v2/:projectId",
        element: <VitalCityV2Dashboard />,
      },
      {
        path: "/city-pulse/:projectId/exceptions",
        element: (
          <PrivateRoute>
            <CityPulseExceptionQueue />
          </PrivateRoute>
        ),
      },
      {
        /* Daily infrastructure health report. Super-admin only: the backend
           403s every /health-check route for other callers. The :runId detail
           route below inherits that gate: canAccessRoute prefix-matches, so
           /admin/health/<id> resolves to this same ROUTES entry. */
        path: "/admin/health",
        element: (
          <PrivateRoute>
            <HealthCheckList />
          </PrivateRoute>
        ),
      },
      {
        path: "/admin/health/:runId",
        element: (
          <PrivateRoute>
            <HealthCheckDetail />
          </PrivateRoute>
        ),
      },
      {
        /* Insight readouts, super-admin only (the backend 403s every
           /readouts route for other callers). The :id detail route inherits
           the gate through canAccessRoute's prefix match. */
        path: "/admin/readouts",
        element: (
          <PrivateRoute>
            <ReadoutList />
          </PrivateRoute>
        ),
      },
      {
        path: "/admin/readouts/:id",
        element: (
          <PrivateRoute>
            <ReadoutDetail />
          </PrivateRoute>
        ),
      },
      {
        /* Proofs of concept, super-admin only (backend 403s the /poc routes
           for everyone else). /poc/livemodelcall is the polling agent on
           GPT-Live-1; canAccessRoute prefix-matches it onto the /poc entry. */
        path: "/poc",
        element: (
          <PrivateRoute>
            <PocList />
          </PrivateRoute>
        ),
      },
      {
        path: "/poc/livemodelcall",
        element: (
          <PrivateRoute>
            <LiveModelCall />
          </PrivateRoute>
        ),
      },
      {
        /* Multilingual ElevenLabs agent: edit, publish and talk to a
           dedicated test agent (backend /poc/elevenlabs/*). */
        path: "/poc/elevenlabs-agent",
        element: (
          <PrivateRoute>
            <ElevenLabsAgentPoc />
          </PrivateRoute>
        ),
      },
      {
        path: "/city-pulse/:projectId",
        element: <CityPulseDashboard />,
      },
      {
        path: "/city-pulse/",
        element: <CityPulseDashboard />,
      },
      {
        /* The redesign's old address (2026-08-14 to 2026-09-11). People were
           given this link, so it keeps working and lands on /vitalcity/. */
        path: "/vitalcity-new/",
        element: <Navigate to="/vitalcity/" replace />,
      },
      {
        path: "/genz-signals/",
        /* key: the two signal pages share one component, and React Router does
           not key route elements - without it, moving between them in the
           sidebar reused the page and kept the other signal's project. */
        element: <GenZSignals key="genz" />,
      },
      {
        path: "/genz-signals/:chatId",
        element: <InsightEngineChat key="genz" genzMode={true} />,
      },
      {
        /* NYC Signal (Vital City, client QA 2026-09-28 A3): the Gen Z Signal
           landing + chat, scoped to the Vital City project. */
        path: "/nyc-signals/",
        element: <GenZSignals key="nyc" variant="nyc" />,
      },
      {
        path: "/nyc-signals/:chatId",
        element: <InsightEngineChat key="nyc" genzMode={true} signalVariant="nyc" />,
      },
      {
        // First-build singular addresses (2026-09-28) redirect to the plural.
        path: "/nyc-signal/",
        element: <Navigate to="/nyc-signals/" replace />,
      },
      {
        path: "/nyc-signal/:chatId",
        element: <LegacyNycSignalChat />,
      },
      {
        path: '/insight-engine/',
        element: <InsightEngine />,
      },
      {
        path: '/insight-engine/gpt',
        element: <Gpt />,
      },
      {
        path: '/insight-engine/default',
        element: <DefaultGpt />,
      },
      {
        path: '/insight-engine/:chatId',
        element: <InsightEngineChat />,
      },
      {
        path: '/surveys/',
        element: <SurveysList />,
      },
      {
        path: '/surveys/launch-survey',
        element: <LaunchSurvey />,
      },
      {
        path: '/manage',
        element: <Manage />,
      },
      {
        path: '/organizations',
        element: <Organization />,
      },
      {
        path: '/organizations/new',
        element: <AddEditOrganization />,
      },
      {
        path: '/organizations/:id',
        element: <AddEditOrganization />,
      },
      {
        path: '/monitoring/users/:userId',
        element: <UserActivity />,
      },
      {
        path: '/user-tracking',
        element: <UserTracking />,
      },
      {
        path: '/all-organizations',
        element: <AllOrganizations />,
      },
    ],
      },
    ],
  },
  // Separate route for Study page without sidebar
  {
    path: '/surveys/study',
    element: (
      <PrivateRoute>
        <NoSidebarLayout />
      </PrivateRoute>
    ),
    children: [
      {
        path: '/surveys/study/:surveyId',
        element: <CreateSurvey />,
      },
      {
        path: '/surveys/study/set-up-study',
        element: <SetUpStudy />,
      },
      {
        path: '/surveys/study/set-up-study/preview',
        element: <Preview />,
      },
      {
        path: '/surveys/study/set-up-study/share/',
        element: <Share />,
      },
    ],
  },
  {
    path: '/survey-entry',
    element: <SurveyEntry />,
  },
  // Public routes for user registration flow — canonical URLs now render the
  // new visual design. Original components are still imported as rollback
  // safety (swap the element back if anything regresses).
  {
    path: '/auth/xv7k2m/:token',
    element: <VerifyInvitationNew />,
  },
  {
    path: '/auth/np2w8q',
    element: <SetPasswordNew />,
  },
  // Forgot-password (self-service): email -> 6-digit code -> hands off to
  // the Set Password page above via the standard sessionToken.
  {
    path: '/auth/fp7r4q',
    element: <ForgotPassword />,
  },
  // Sign-in link 2FA public routes (user-visible)
  {
    path: '/auth/sign-in/check',
    element: <MagicLinkVerifyNew />,
  },
  {
    path: '/auth/sign-in/:token',
    element: <MagicLinkLandingNew />,
  },
  // Legacy magic-link URLs kept as aliases for any old in-flight emails (safe to remove later)
  {
    path: '/auth/magic-link/verify',
    element: <MagicLinkVerifyNew />,
  },
  {
    path: '/auth/magic-link/:token',
    element: <MagicLinkLandingNew />,
  },
  // The "-new" URL aliases stay mounted so any tester bookmarks / inflight
  // invitation links keep working — they're now duplicates of the canonical URLs above.
  {
    path: '/auth/xv7k2m-new/:token',
    element: <VerifyInvitationNew />,
  },
  {
    path: '/auth/np2w8q-new',
    element: <SetPasswordNew />,
  },
  {
    path: '/auth/sign-in-new/check',
    element: <MagicLinkVerifyNew />,
  },
  {
    path: '/auth/sign-in-new/:token',
    element: <MagicLinkLandingNew />,
  },
  // Catch-all route for 404 - must be last
  {
    path: '*',
    element: <NotFoundPage />,
  },
    ],
  },
]);

function App() {
  return (
    <ThemeProvider theme={Theme}>
      <AppInitializer>
        <RouterProvider router={router} />
        <SessionInvalidatedModal />
        <SessionExpiredModal />
      </AppInitializer>
    </ThemeProvider>
  );
}

export default App;
